import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { user } from '€slices/user';
import { generateRoute, Routes } from '€lib/routing';
import cx from 'classnames';
import { useStyles } from './styles';
import {
    Avatar,
    useMediaQuery,
    useTheme,
    Divider,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';
import MuiRouterLink from '€components/MuiRouterLink';
import DashboardSVG from '€components/svgs/dashboard.svg';
import CaseListSVG from '€components/svgs/caseList.svg';
import ReferAClientSVG from '€components/svgs/referAClient.svg';

const DashboardSideNav: React.FC = () => {
    const $user = useSelector(user);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const classes = useStyles();
    const { pathname } = useLocation();

    return (
        <nav className={classes.list}>
            <MuiRouterLink
                to={{
                    pathname: `${matches ? Routes.UserDetails : Routes.UserSettings}`,
                    state: {
                        path: Routes.Dashboard,
                    },
                }}
                underline="none"
            >
                <ListItem style={{ marginBottom: 5 }}>
                    <ListItemIcon className={classes.listIcon}>
                        <Avatar className={classes.avatar}>{$user.initials}</Avatar>
                    </ListItemIcon>
                    <ListItemText primary={$user.name} className={classes.inActive} />
                </ListItem>
            </MuiRouterLink>
            <MuiRouterLink
                to={Routes.Dashboard}
                underline="none"
                color="inherit"
                className={cx({
                    [classes.active]: pathname === Routes.Dashboard,
                    [classes.inActive]: pathname !== Routes.Dashboard,
                })}
            >
                <ListItem button>
                    <ListItemIcon className={classes.listIcon}>
                        <DashboardSVG />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItem>
            </MuiRouterLink>
            <Divider />
            <MuiRouterLink
                to={Routes.ApplicationsList}
                underline="none"
                color="inherit"
                className={cx({
                    [classes.active]: pathname === Routes.ApplicationsList,
                    [classes.inActive]: pathname !== Routes.ApplicationsList,
                })}
            >
                <ListItem button>
                    <ListItemIcon className={classes.listIcon}>
                        <CaseListSVG />
                    </ListItemIcon>
                    <ListItemText primary="Case List" />
                </ListItem>
            </MuiRouterLink>
            <Divider />
            <MuiRouterLink
                to={{
                    pathname: `${generateRoute(Routes.ReferAClient, {
                        campaignId: $user.campaignId,
                    })}`,
                }}
                underline="none"
                color="inherit"
                className={cx({
                    [classes.active]: pathname === Routes.ReferAClient,
                    [classes.inActive]: pathname !== Routes.ReferAClient,
                })}
            >
                <ListItem button>
                    <ListItemIcon className={classes.listIcon}>
                        <ReferAClientSVG />
                    </ListItemIcon>
                    <ListItemText primary="Refer a Client" />
                </ListItem>
            </MuiRouterLink>
            <Divider />
        </nav>
    );
};

export default DashboardSideNav;
